import { patchSubmodelElementValue, createSubmodelElement, fetchSubmodel } from '../../services/DppManagerService';
import { returnTrackingNumber } from '../../sm-templates/CircularEconomy';

const ReturnNumberHandler = async ({ data, setError, setSuccess, smId}) => {

  const idShortReturnTrackingNumber = 'ReturnTrackingNumber';
  try {
    if (!smId || !data) {
      throw new Error('Submodel ID and form data are required');
    }

    const newValue = data?.returnNumber.toString() || '';

    const submodel = await fetchSubmodel(smId);

    // Check if property already exists
    const existingElement = submodel?.submodelElements?.find(
      el => el.idShort === idShortReturnTrackingNumber
    );

    if (existingElement) {
      await patchSubmodelElementValue(smId, idShortReturnTrackingNumber, newValue);
    } else {
      const payload = JSON.parse(JSON.stringify(returnTrackingNumber));
      payload.value = newValue;
      await createSubmodelElement(smId, payload);
    }

    const successMessage = <>
        {'Aktion erfolgreich.'}{' '}
        <a className="alert-link" href="#" onClick={() => window.location.reload()}>
          {'Seite neu laden um Änderungen zu sehen'}
        </a>
    </>;
    setSuccess(successMessage);

  } catch (err) {
    console.error('Failed to create ServiceRequestNotification:', err);
    setError(err.message || 'Fehler beim Erstellen der Serviceanfrage.');
  }
};

export default ReturnNumberHandler;